<template>
    <div class="main visible">
        <div class="content">
            <div class="close" @click="closeApp()"></div>
            <Intro v-if="phase === 0" @setPhase="setPhase" />
            <Question v-if="phase === 1" :question="questionForPhaseOne" @handleAnswer="storeAnswer" @back="goBack" />
            <Question v-if="phase === 2" :question="questionForPhaseTwo" @handleAnswer="storeAnswer" @back="goBack" />
            <Question v-if="phase === 3" :question="questionForPhaseThree" @handleAnswer="storeAnswer" @back="goBack" />
            <Final
                v-if="phase === 4"
                :heading="finalHeading"
                :answers="answers"
                @back="goBack"
                @signUp="signUp"
                @moreFaqs="moreFaqs"
            />
        </div>
    </div>
</template>

<script>
import Intro from '@/components/Intro.vue'
import Question from '@/components/Question.vue'
import Final from '@/components/Final.vue'
import jsonQuestions from '@/assets/data/questions.json'
import jsonFinalHeadings from '@/assets/data/finalHeadings.json'

export default {
    name: 'Main',
    components: {
        Intro,
        Question,
        Final
    },
    data () {
        return {
            appIsVisible: this.$ls.get('appIsVisible'),
            phase: 0,
            questions: jsonQuestions,
            finalHeadings: jsonFinalHeadings,
            answers: [],
            finalHeading: null
        }
    },
    computed: {
        questionForPhaseOne () {
            return this.questions.find(o => o.phase === 1)
        },
        questionForPhaseTwo () {
            return this.questions.find(o => o.phase === 2)
        },
        questionForPhaseThree () {
            let questions = JSON.parse(JSON.stringify(this.questions.find(o => o.phase === 3)))
            if (this.answers[0] && this.answers[0].answer === 'child') {
                const answers = questions.answers.filter(o => o.id !== 2)
                questions.answers = answers
            }
            
            return questions
        },
        urlPostfix () {
            let age = this.answers[0].answer
            let type = this.answers[2].answer === 'competition' ? 'competition' : 'recr'
            return `${age}${type}/?utm_source=kh&utm_campaign=keuzehulp&utm_id=v1&utm_term=${age}+${type}&utm_content=${age}${type}`
        }
    },
    watch: {
        answers: {
            deep: true,
            handler (newValue) {
                // console.log(JSON.stringify(newValue, null, 2))
                this.$nextTick(() => {
                    if (newValue.length > 2) {
                        // console.log(newValue[2].answer)
                        this.finalHeading = this.finalHeadings.find(o => o.goal === newValue[2].answer && o.age === newValue[0].answer)['heading']
                    }
                })
            }
        }
    },
    mounted () {
        this.$ls.set('appIsVisible', true)
        this.$ls.on('appIsVisible', (val) => {
            this.appIsVisible = val
        })
    },
    methods: {
        setPhase (phase) {
            this.phase = phase
        },
        storeAnswer (questionCode, answerCode) {
            let data = {
                question: questionCode,
                answer: answerCode,
            }

            if (this.phase <= 1) {
                this.answers = []
            }

            if (questionCode === 'age' && answerCode === 'child') {
                // shortcut for wiko
                this.answers.push(data)
                this.answers.push({ question: 'level', answer: 'beginner' })
                this.phase = 3
            } else {
                if (this.answers.length >= this.phase) {
                    this.answers.splice((this.phase - 1), (this.answers.length - this.phase + 1))
                }
                this.answers.push(data)
            
                this.phase = this.phase + 1
            }
        },
        goBack () {
            if (this.answers[0] && this.answers[0].answer === 'child') {
                // shortcut back for wiko
                this.phase = 1
                this.answers = []
            } else {
                this.phase--;
                this.answers.splice(this.phase, 1);
            }
        },
        closeApp () {
            this.$ls.set('appIsVisible', false)
        },
        signUp () {
            console.log('sign up')
            window.location.href = `/lid-worden/${this.urlPostfix}`
        },
        moreFaqs () {
            window.location.href = `/faq/${this.urlPostfix}`
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '@/assets/scss/main.scss';

    .main {
        display: none;

        &.visible {
            display: block;
        }
    }

    .close {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        width: 2rem;
        height: 2rem;
        opacity: 0.67;
        background: transparent center / contain no-repeat url('/img/times.svg');
        cursor: pointer;
        @include transition-out();

        &:hover {
            opacity: 1;
            transform: scale(1.2, 1.2);
           @include transition-in();
        }

        @include bp-lg {
            top: 2rem;
            right: 2rem;
        }
    }
    
</style>